const MAX_RECENT_APPLICATIONS = 20

export const recentApplicationsKey = (userId: string | number) =>
  `app2RecentApplications:${userId}`

export const readRecentApplications = (userId: string | number): number[] => {
  try {
    const stored: unknown = JSON.parse(
      localStorage.getItem(recentApplicationsKey(userId)) ?? '[]'
    )
    if (!Array.isArray(stored)) return []
    return [
      ...new Set(
        stored.filter(
          (id): id is number =>
            typeof id === 'number' && Number.isSafeInteger(id) && id > 0
        )
      ),
    ].slice(0, MAX_RECENT_APPLICATIONS)
  } catch {
    return []
  }
}

export const rememberRecentApplication = (
  userId: string | number,
  applicationId: number
) => {
  const previous = readRecentApplications(userId)
  if (!Number.isSafeInteger(applicationId) || applicationId <= 0)
    return previous
  // Keep existing entries in place so switching cases does not move targets.
  if (previous.includes(applicationId)) return previous
  const recent = [applicationId, ...previous].slice(0, MAX_RECENT_APPLICATIONS)
  try {
    localStorage.setItem(recentApplicationsKey(userId), JSON.stringify(recent))
  } catch {
    // Navigation still works when browser storage is unavailable.
  }
  return recent
}
